import { MessagingHelper } from "../helpers/MessagingHelper";
import { SettingsTypeDTO } from "../models/Settings/SettingsTypeDTO";
import { APIService } from "./APIService";

export class SettingsTypeService {

    async GetAll(): Promise<MessagingHelper<SettingsTypeDTO[]>> {
        try {
            var response = await APIService.Axios().get(
                `${APIService.GetURL()}/SettingsType/GetAll`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<SettingsTypeDTO[]>(
                false,
                "Erro ao ligar ao servidor para obter tipos de definições",
                [],
            );
        }
    }

}